// extracted by mini-css-extract-plugin
module.exports = {"movie-info":"MovieInfo_movie-info__1Atng","poster":"MovieInfo_poster__37N19","btn-bookmark":"MovieInfo_btn-bookmark__qyLLD","btn-favourite":"MovieInfo_btn-favourite__3rsVy"};